package br.com.logicalside.proposes.pages

import Res
import androidx.compose.runtime.Composable
import br.com.logicalside.proposes.components.layouts.InnerContainer
import br.com.logicalside.proposes.components.layouts.PageLayout
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.core.Page
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.dom.*

@Page
@Composable
fun TermsPage() {
    PageLayout(Res.string.terms_of_use) {
        InnerContainer(Modifier.padding(leftRight = 2.cssRem)) {
            Column {
                H1 { Text(Res.string.terms_screen_title) }
                Div { Text(Res.string.terms_screen_description) }

                P()

                H3 { Text(Res.string.terms_screen_item_1) }
                P { Text(Res.string.terms_screen_item_1_1_text) }
                P { Text(Res.string.terms_screen_item_1_2_text) }
                P { Text(Res.string.terms_screen_item_1_3_text) }

                H3 { Text(Res.string.terms_screen_item_2) }
                P { Text(Res.string.terms_screen_item_2_1_text) }

                H3 { Text(Res.string.terms_screen_item_3) }
                P { Text(Res.string.terms_screen_item_3_1_text) }

                H3 { Text(Res.string.terms_screen_item_4) }
                P { Text(Res.string.terms_screen_item_4_1_text) }

                H3 { Text(Res.string.terms_screen_item_5) }
                P { Text(Res.string.terms_screen_item_5_1_text) }
                P { Text(Res.string.terms_screen_item_5_2_text) }
                P { Text(Res.string.terms_screen_item_5_3_text) }
                P { Text(Res.string.terms_screen_item_5_4_text) }

                H3 { Text(Res.string.terms_screen_item_6) }
                P { Text(Res.string.terms_screen_item_6_1_text) }

                H3 { Text(Res.string.terms_screen_item_7) }
                P { Text(Res.string.terms_screen_item_7_1_text) }

                H3 { Text(Res.string.terms_screen_item_8) }
                P { Text(Res.string.terms_screen_item_8_1_text) }

                H3 { Text(Res.string.terms_screen_item_9) }
                P { Text(Res.string.terms_screen_item_9_1_text) }

                Br()
            }
        }
    }
}
